export default __webpack_public_path__ + "static/media/loginImg.4f97218f.png";